import Gl from '../Gl'

import ScenePostProcessing from './Scenes/ScenePostProcessing'

export default class World {
  constructor() {
    this.gl = new Gl()

    /* 
      Flags
    */
    this.isControlsAllowed = false

    /* 
      Scenes
    */
    this.selectors = []
    this.scenes = []

    /* 
      Debug
    */
    if (this.gl.isDebug) this.setDebug()
  }

  setDebug() {
    this.debugSceneParamsFolder = this.gl.debug.gui.addFolder({
      title: 'Scene Parameters',
    })

    this.debugWorldFolder = this.gl.debug.gui.addFolder({
      title: 'World',
      expanded: false,
    })

    this.debugWorldFolder.addBinding(this, 'isControlsAllowed', {
      label: 'Controls Allowed',
    })
  }

  add() {
    this.scenes.push(new ScenePostProcessing())

    for (const key in this.scenes) {
      this.scenes[key].renderPlane.mesh.setParent(this.gl.scene)
    }
  }

  resize() {
    for (const key in this.scenes) {
      this.scenes[key].resize()
    }
  }

  update() {
    for (const key in this.scenes) {
      this.scenes[key].update()
    }
  }
}
